import { atom } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { fetchUserReferralsRequestAction } from '@root/entities/referral'
import { dataTableNoAccessError, reatomDataTable } from '@root/shared/ui-kit'

import { referralTableColumns } from '../ui/desktop/referrals-table-columns'

export const reatomReferralsTable = () => {
  const paramsAtom = atom((ctx) => {
    const isLoggedIn = ctx.spy(isLoggedInAtom)
    return {
      isLoggedIn: isLoggedIn,
    }
  }, 'paramsAtom')

  const tableModel = reatomDataTable({
    columns: referralTableColumns,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomReferralsTable',
    paramsAtom: paramsAtom,
    loadItems: async (ctx, { pagination: _, params: { isLoggedIn } }) => {
      if (!isLoggedIn) {
        return Result.fail(dataTableNoAccessError())
      }

      const referrals = await fetchUserReferralsRequestAction(ctx)

      return pipe(
        referrals,
        Result.map((data) => ({
          data: data,
        })),
      )
    },
    limit: 20,
    getId: ({ id }) => id,
  })

  return tableModel
}
